import React from 'react';
import {
  InfoContainer,
  InfoValue,
  BlockchainLink,
} from './style-component';
import { CollectionDetailsProps } from './collection-details-types';
import OpenSeaLogo from '../../../assets/icons/open-sea/open-sea.svg';
import { getOpenSeaUrl } from '@/utils/get-open-sea-url/get-open-sea-url';

export const CollectionDetails: React.FC<CollectionDetailsProps> = ({
  blockchain_name,
  collection_key,
}) => {

  return (
    <InfoContainer>
      <InfoValue>
            <BlockchainLink 
              href={getOpenSeaUrl(blockchain_name, collection_key)} 
              target="_blank"
              rel="noopener noreferrer"
            >
              <img 
                src={OpenSeaLogo}
                alt="OpenSea" 
                style={{ 
                  width: '16px', 
                  height: '16px', 
                  marginRight: '4px',
                  verticalAlign: 'middle' 
                }} 
              />
              Ver en OpenSea
            </BlockchainLink>
      </InfoValue>
    </InfoContainer>
  );
}; 